import * as React from "react";
import { TextComponentProps, TextComponentState, TextComponentHandler } from "../textcomponent";
import { TextCSSStyle } from "../textcss";
import { TextViewImpl } from "../textview";

export class MemberTextViewImpl extends TextViewImpl
{
    bindHandlers()
    {
        this.onChange = this.onChange.bind(this);
    }

    draw(props: TextComponentProps, state: TextComponentState, cssStyle: TextCSSStyle): JSX.Element | boolean
    {   
         return (
                <div style={cssStyle.getWrapperCSSStyle()}>
                    {props.label !== "" && <label style={cssStyle.getTextLabelCSSStyle()}>{props.label}
                        {props.isRequired && !props.isDisabled && <label style={cssStyle.getLabelStartCSSStyle()}>
                           {"*"}
                        </label>}
                </label>}
                    
                    <input autoFocus={true} disabled={props.isDisabled}  value={state.value} type={props.inputType} onChange={this.onChange} style={state.errorMessage !== undefined ? cssStyle.getErrorCSSStyle() : cssStyle.getTextCSSStyle(state.class === "" ? false : true , props.isDisabled)} placeholder={props.placeholder}/>

                    {
                        state.errorMessage !== undefined && <div style={cssStyle.getErrorTextDivCSSStyle()}>
                        <label style={cssStyle.getErrorTextCSSStyle(this.getContext().getUserContext().getLanguage())}>{state.errorMessage}</label> </div>}
                </div>
       );
    }


    
    onChange(event: any)
    {
        (this.getUIComponentHandler() as TextComponentHandler).onChange(event.target.value);
    }
  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/text/membertext/membertextview.tsx